import React from 'react';
import Page from '../../components/Page/Page';
import { Outlet } from 'react-router-dom';
import styled from '@emotion/styled';

const Blog = () => {
  return (
    <Page title="Locumspace | Blog">
      <Main>
        <Outlet />
      </Main>
    </Page>
  );
};

export default Blog;

const Main = styled.main`
  min-height: 100vh;
  padding-top: 4rem;

  @media (max-width: 480px) {
    padding-top: 3rem;
  }
`;
